// extracted by mini-css-extract-plugin
export var button = "TinyButton-module--button--84a25";
export var dangerous = "TinyButton-module--dangerous--13b21";
export var disabled = "TinyButton-module--disabled--76f41";
export var primary = "TinyButton-module--primary--4df6e";
export var secondary = "TinyButton-module--secondary--93cf6";